/**
 * Maps user level to a color theme for chat display
 * @param {number} level - The user's level
 * @returns {string} - Hex color code
 */
export function getLevelColorTheme(level) {
  const levelColors = {
    1: '#9CA3AF', // Gray
    2: '#10B981', // Green
    3: '#3B82F6', // Blue
    4: '#8B5CF6', // Purple
    5: '#F59E0B', // Amber
    6: '#EF4444', // Red
    7: '#EC4899', // Pink
    8: '#14B8A6', // Teal
    9: '#F97316', // Orange
    10: '#6366F1', // Indigo
  };
  
  // For levels above 10, cycle through colors
  if (level > 10) {
    const colors = Object.values(levelColors);
    return colors[(level - 1) % colors.length];
  }
  
  return levelColors[level] || levelColors[1];
}

